const BIRTH_RECORD_UPDATED_EVENT = 'astroai:birth-record-updated'

export const notifyBirthRecordUpdated = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(
    new CustomEvent(BIRTH_RECORD_UPDATED_EVENT, {
      detail: {
        occurredAt: new Date().toISOString(),
      },
    }),
  )
}

export const subscribeToBirthRecordUpdated = (listener: () => void) => {
  if (typeof window === 'undefined') {
    return () => undefined
  }

  const handler = () => listener()
  window.addEventListener(BIRTH_RECORD_UPDATED_EVENT, handler)

  return () => {
    window.removeEventListener(BIRTH_RECORD_UPDATED_EVENT, handler)
  }
}
